export default __webpack_public_path__ + "static/media/stacking.1b964d8a.svg";